export const STORE_LOGIN_INFO = 'loginInfoStore';
export const LI_SET_OPTIONS = 'setOptions';
export const LI_SET_INFO = 'setInfo';
export const LI_SAVE_DATA = 'saveData';
export const LI_DELETE_INFO = 'deleteInfo';
export const LI_ADD_MORE = 'addMore';
export const LI_MAX_INFOS = 3;
